export { default as TeacherDetail } from "./TeacherDetail";
export { default as TeacherList } from "./TeacherList";

